import { useState } from "react";
import { Hero } from "../components/home/Hero";
import { TrustBar } from "../components/home/TrustBar";
import { ServicesGrid } from "../components/home/ServicesGrid";
import { FeaturedProjects } from "../components/home/FeaturedProjects";
import { GovernmentCTA } from "../components/home/GovernmentCTA";
import { Testimonials } from "../components/home/Testimonials";
import { CTASection } from "../components/home/CTASection";
import { IntroAnimation } from "../components/IntroAnimation";

export default function Home() {
  const [showIntro, setShowIntro] = useState(() => !sessionStorage.getItem("fosche_intro_seen"));

  return (
    <div data-testid="home-page">
      {showIntro && <IntroAnimation onDone={() => setShowIntro(false)} />}
      <Hero />
      <TrustBar />
      <ServicesGrid />
      <FeaturedProjects />
      <GovernmentCTA />
      <Testimonials />
      <CTASection />
    </div>
  );
}
